<template>
  <div class="page">
    <div class="head">《关于呼和浩特线上专业技术人员继续教育平台》</div>
    <div class="main">
      平台结合互联网、移动互联 网、云服务，采用全新的系统架构和算法设计开发，具有操作就简单、管理便捷、稳
      定可靠、安全高效、兼容性广等优势。平台注重学员在线学习过程中的易用性和用户
      体验，同时更加关注培训的运维效率，实现教、学、考、研、管等多种功能，为专业技术人员继续教育搭建一个统一规范、快速便捷的学习、管理平台。
      平台课程资源来自来政府、研究机构、高等院校、行业专家、学者等精心构建具有
      前瞻性的课程资源，海量网络培训课程库满足全自治区专业技术人员培训学习需要。课
      程体系涵盖党建、经济政策、科技、职业技能、素质能力等近1000个以上课程主题，共
      计3000门左右，覆盖干部培训的全部知识体系。目前平台拥有建筑、金融、法律、教
      育、医卫、财务、市政等70门专业课程，近12000学时的优质网络课程资源。
      内蒙古线上专业技术人员继续教育平台将以自己的技术、课程资源和服务优势扎根服务内蒙古，以前沿信息
      技术为支撑，立足本地化线上教育培训服务，推动学员终身学习，面向党政机关、
      国企、中大型企业提供全流程数字化培训服务，立志成为内蒙古专业的继续教育服务平台。
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},

  data() {
    // 这里存放数据
    return {};
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    window.scrollTo(0, 0);
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
.page {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.head {
  margin-top: 40px;
  text-align: center;
}
.main {
  margin-top: 40px;
  width: 1200px;
  height: 1626px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
</style>
